module.exports = __webpack_public_path__ + "static/media/todolist4.b40199cb.png";